<div class="pre-login">
    <div class="pre-login-col-1 h-100">
        <left-panel-onboarding></left-panel-onboarding>
    </div>
    <div class="pre-login-col-2">
    </div>
    <div class="pre-login-col-3">
        <div class="onboarding-canvas">
            <!-- <div class="custom-tab mt-50 pr-50 mt-mobile-0 pr-mobile-0">
                <div class="custom-tab-item" [ngClass]="activeTab == 1 ? 'active' : ''" (click)="changeTab(1)">
                    {{"AR" | translate}}
                </div>
                <div class="custom-tab-item" [ngClass]="activeTab == 2 ? 'active' : ''" (click)="changeTab(2)">
                    {{"EN" | translate}}
                </div>
            </div> -->
                  <div class="font-400 font-size-24px line-h-32 color-base-1300">
                                {{ "Enter your password" | translate }}
                    </div>
                            <div class="font-300 font-size-18px line-h-32 color-base-1300">
                                {{ "Please authenticate with your password to proceed" | translate }}
                            </div>
                            <form [formGroup]="passwordForm">
                                <div class="form-group password-eye mt-30">
                                    <label class="no-mark">
                                        {{ "Password" | translate }}
                                    </label>
                                    <input type="password" [(ngModel)]="password" showPassword
                                        formControlName="passworform" maxlength="16" placeholder="Please enter password"
                                        class="form-control" />

                                    <!-- Validation messages -->
                                    <ng-container *ngFor="let validation of errorKey.validation_messages.password2">
                                        <span class="error-label" *ngIf="passwordForm.get('passworform')?.hasError(validation.type) 
                   && passwordForm.get('passworform')?.touched">
                                            {{ getMessage(validation.key,'password2') }}
                                        </span>
                                    </ng-container>
                                </div>
                            </form>

                            <strong
                                class="font-500 font-size-14px line-h-32 color-base-1300 mt-15 cursor-pointer text-uppercase letter-spacing-1"
                                (click)="forgotPass()" >
                               
                                {{ "ForgotPassword" | translate }}
                            </strong>


                            <grid-row class="justify-content-between align-item-center mt-50">
                                <grid-col col="auto">
                                    <div class="mt-15">
                                        <button class="btn-back" (click)="back()">
                                            <i class="icon-back"></i>
                                        </button>
                                    </div>
                                </grid-col>
                                <grid-col col="9">
                                    <button class="btn-dft" (click)="passwordflow()" [disabled]="isValid()">
                                        {{ "Login" | translate }}
                                    </button>
                                </grid-col>
                            </grid-row>



                                            <!-- <div class="mt-10">
                                    <img src="assets/images/enjoy-imtiaz.png" alt="">
                                </div> -->


        </div>
    </div>
</div>
